import React from "react";
import LegalPageLayout, { LegalList, LegalSection } from "./LegalPageLayout";
import { SUPPORT_EMAIL } from "../common/SiteFooter";

const RefundPolicy: React.FC = () => (
  <LegalPageLayout
    title="Refund & Cancellation Policy"
    lastUpdated="31 August 2026"
  >
    <p>
      This policy explains how to cancel your Astria subscription, when refunds
      are available, and how long they take to process.
    </p>

    <LegalSection heading="1. Cancelling Your Subscription">
      <p>
        You can cancel at any time from your account, or by emailing{" "}
        {SUPPORT_EMAIL} from the address associated with your account. When you
        cancel:
      </p>
      <LegalList
        items={[
          "Your plan stays active until the end of the billing period you have already paid for.",
          "You keep full access to paid features for the remainder of that period.",
          "No further payments are taken after cancellation.",
        ]}
      />
    </LegalSection>

    <LegalSection heading="2. Refund Eligibility">
      <LegalList
        items={[
          <>
            <strong className="font-semibold text-[#1B1511]">
              Duplicate charges:
            </strong>{" "}
            If you were charged more than once for the same subscription, the
            duplicate charge will be refunded after verification.
          </>,
          <>
            <strong className="font-semibold text-[#1B1511]">
              Technical faults:
            </strong>{" "}
            If a significant technical issue on our side prevented you from
            accessing the Service for a substantial part of your paid billing
            period and we were unable to resolve the issue, we may provide a
            full or pro-rated refund at our discretion.
          </>,
          <>
            <strong className="font-semibold text-[#1B1511]">
              Renewal charges:
            </strong>{" "}
            Subscription renewal charges are generally non-refundable once the
            renewal has been processed, except where required by applicable law
            or in cases of verified billing errors.
          </>,
          <>
            <strong className="font-semibold text-[#1B1511]">
              Change of mind or dissatisfaction:
            </strong>{" "}
            Payments are generally non-refundable solely because you did not
            like the Service, its content, readings, insights, or results.
          </>,
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. How to Request a Refund">
      <p>
        Email{" "}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="font-medium text-[#1B1511] underline underline-offset-4"
        >
          {SUPPORT_EMAIL}
        </a>{" "}
        from your account email address and include the plan you purchased, the
        approximate date of the charge, and a short description of the reason.
        We acknowledge requests within 2 business days.
      </p>
    </LegalSection>

    <LegalSection heading="4. Processing Time">
      <p>
        Approved refunds are issued to the original payment method via Stripe.
        We submit the refund within 5 business days of approval; your bank or
        card issuer typically takes a further 5 to 10 business days to show the
        funds, depending on their processing times.
      </p>
    </LegalSection>

    <LegalSection heading="5. Statutory Rights">
      <p>
        This policy is in addition to any refund or cancellation rights you have
        under the consumer laws of your country, and does not limit them.
      </p>
    </LegalSection>

    <LegalSection heading="6. Contact">
      <p>
        For any question about billing, cancellation, or refunds, write to{" "}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="font-medium text-[#1B1511] underline underline-offset-4"
        >
          {SUPPORT_EMAIL}
        </a>
        .
      </p>
    </LegalSection>
  </LegalPageLayout>
);

export default RefundPolicy;
